module.exports = __webpack_public_path__ + "img/logo.439f48ea.png";